import React from "react";

const Title = ({ title }) => {
  return <h2>{title}</h2>;
};

export default Title;
